import { render } from "./RegularMovingGeoTemplateDetailTable.vue?vue&type=template&id=122b1adc&scoped=true"
import script from "./RegularMovingGeoTemplateDetailTable.vue?vue&type=script&lang=js"
export * from "./RegularMovingGeoTemplateDetailTable.vue?vue&type=script&lang=js"

import "./RegularMovingGeoTemplateDetailTable.vue?vue&type=style&index=0&id=122b1adc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122b1adc"]])

export default __exports__